import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogComponent } from './dialog.component';
import { DirectiveModule } from 'src/app/shared/directive';
import { AlertComponent } from './alert/alert.component';
import { PipesModule } from '../pipes';
import { TermsAndConditionDynamicComponent } from './terms-and-condition-dynamic/terms-and-condition-dynamic.component';
import { ErrorComponent } from './error/error.component';

const IMPORT_COMPONENT = [
  AlertComponent,
  TermsAndConditionDynamicComponent,
  ErrorComponent
]
@NgModule({
    imports: [CommonModule, FormsModule, DirectiveModule, PipesModule],
    declarations: [DialogComponent, ...IMPORT_COMPONENT]
})
export class DialogModule { }
